export default {
    upload: 'Datei hochladen',
    orDragAndDrop: 'oder hierher ziehen'
}
